module.exports = __webpack_public_path__ + "img/person.79689fc2.svg";